import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditTaskProgress, TaskDetails, TaskProgressActivity } from "../../components/task";
import { TaskService } from "../../services";
import { CREATE_TASK_PROGRESS, VIEW_TASK_PROGRESS } from "../../constants";
import { useHasPermission } from "../../utils";

export const SingleTask = () => {
  const [task, setTask] = useState({});
  const [taskProgressQuantity, setTaskProgressQuantity] = useState(0);
  const [open, setOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [reload, setReload] = useState(0);

  const { id } = useParams();

  const hasViewTaskProgress = useHasPermission(VIEW_TASK_PROGRESS);
  const hasCreateTaskProgress = useHasPermission(CREATE_TASK_PROGRESS);

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const fetchData = async (taskId) => {
    try {
      const { data: task } = await TaskService.getTaskById(taskId);
      setTask(task);
    } catch (error) {
      console.error("🚀 ~ fetchData ~ error:", error);
      toast.error("Failed to fetch task details.");
    }
  };

  const handleReload = () => {
    setReload((prev) => prev + 1);
    fetchData(id);
  };

  const buttons = [
    hasCreateTaskProgress && {
      buttonText: "Add Progress",
      buttonIcon: Add,
      onClick: () => {
        if (task?.quantity === taskProgressQuantity) {
          toast.info("Task is already completed. No more progress can be added.");
          return;
        }
        setOpen(true);
      },
    },
  ];
  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title={task?.name || "Task Progress"}
            subtitle={`${totalCount} task progress`}
            // button
            buttons={buttons}
          />
        </Box>

        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <Box sx={{ display: "flex" }}>
            <Box flex={1}>
              <TaskDetails taskData={task} taskProgressQuantity={taskProgressQuantity} reloadData={() => fetchData(id)} />
            </Box>
            {hasViewTaskProgress && (
              <Box flex={1}>
                <TaskProgressActivity
                  totalCount={totalCount}
                  setTotalCount={setTotalCount}
                  taskDetails={task}
                  taskProgressQuantity={taskProgressQuantity}
                  setTaskProgressQuantity={setTaskProgressQuantity}
                  fetchTaskDetails={() => fetchData(id)}
                  reloadData={reload}
                />
              </Box>
            )}
          </Box>
        </Box>
      </PageLayout>

      {/* add progress */}
      <AddEditTaskProgress
        open={open}
        onClose={() => setOpen(false)}
        taskQuantity={task?.quantity}
        taskProgressQuantity={taskProgressQuantity}
        taskStatus={task?.status}
        onSuccess={handleReload}
      />
    </>
  );
};
